import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Divider, useWindowSize } from '@teko/ui';
import { BuildPcItem } from '../BuildPcItem/BuildPcItem.es.js';
import { NoProductsFound } from '../../Common/NoProductsFound/NoProductsFound.es.js';
import { Loading } from '../../Common/Loading/Loading.es.js';

const StyledBuildPcItem = styled(BuildPcItem)`
  border-radius: unset;
  padding: 0.625rem 1rem;
  &:hover {
    box-shadow: unset;
  }
`;
const Wrapper = styled.div`
  height: ${(props) => props.height + "rem"};
  overflow-y: scroll;
  overflow-x: hidden;
  border-bottom: 1px dashed #ddd;
  border-top: 1px dashed #ddd;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #999;
  }
`;
const StyledDivider = styled(Divider)`
  width: 95%;
  margin: auto;
`;
const StyledNoProductsFound = styled(NoProductsFound)`
  margin-top: 5rem;
`;
const BuildPcModalContent = ({
  products = [],
  isLoading,
  onClick
}) => {
  const windowSize = useWindowSize();
  return /* @__PURE__ */ React.createElement(Loading, {
    top: 150,
    isLoading: !!isLoading
  }, /* @__PURE__ */ React.createElement(Wrapper, {
    height: ((windowSize == null ? void 0 : windowSize.width) || 0) > 1600 ? 34.08 : 22.725
  }, /* @__PURE__ */ React.createElement(StyledNoProductsFound, {
    show: !isLoading && !products.length
  }), products.map((product, index) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: product.sku
  }, /* @__PURE__ */ React.createElement(StyledBuildPcItem, {
    onClick: () => onClick(product.sku),
    key: product.sku,
    product,
    actionText: t("Ch\u1ECDn")
  }), index < products.length - 1 && /* @__PURE__ */ React.createElement(StyledDivider, null)))));
};

export { BuildPcModalContent };
